module.exports = __webpack_public_path__ + "assets/img/treatment.webp?99aebcf4b0c20f48cc0eb7398875ee85";